import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import protectRoute from '../../hoc/protectRoute'
import { rootRoute } from '../root'

const Profile = lazyRouteComponent(() => import('../../pages/profile/profile'))

export const profileRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'profile',
  component: protectRoute(Profile, true),
})
